module.exports = __webpack_public_path__ + "static/fee07-43310746b490a90bc7486d85d657a261.png";